import React, { useState, useEffect } from "react";
import "../styles/CarwashPage.css";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import SEO from "../components/SEO";

import * as productService from "../_services/products.service";

export default function MagyneCarwashPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const [product, setProduct] = useState(location.state?.product || null);
  const params = new URLSearchParams(location.search);
  const proceedTo = params.get("proceedTo") || "register";
  const tenantId = params.get("tenantId") || null;
  const productId = params.get("productId") || "5a28c17b-0d18-4f94-967d-ccedacd0f39c";

  const handleNavigate = () => {
    navigate(`/pricing/?productId=${product.productId}&proceedTo=${proceedTo}&tenantId=${tenantId}`, {state:{product}})
  }

  useEffect(() => {
    const fetchProduct = async () => {
      if (!product && productId) {
        setLoading(true);
        try {
          const getProduct = await productService.get({
            productId,
            status: "all"
          });
          if(!getProduct.data?.length){
            setProduct(null);
          }
          setProduct(getProduct.data[0]);
        } catch (error) {
          toast.error(error.messaage || "Failed to fetch product details.");
        } finally {
          setLoading(false);
        }
      }
    }

    fetchProduct();
  }, [product, productId]);


  return (
    <>
    <SEO
      title="Magyne Carwash | Car Wash Management & POS Software"
      description="Magyne Carwash provides management and POS software for car wash businesses, including services, pricing, customers, receipts and operations."
      path="/solutions/carwash"
    />
    <main>
      <div className="carwash-page">
        {/* Background */}
        <div className="bg-blobs">
          <div className="blob blob1"></div>
          <div className="blob blob2"></div>
          <div className="blob blob3"></div>
        </div>

        {
          loading 
          ?
            <div>
              <div className="spinner"></div>
              <p className="text-center">
                Loading products. <br/>
                Please wait...
              </p>
            </div>
          :!loading && product 
          ? (
            <>
          <section
            className="carwash-hero"
            style={{
              backgroundImage: "url('/images/carwash.jpg')",
            }}
          >
            <div className="carwash-hero-overlay">
              <h1>Magyne Carwash <br/> Car Wash Management Software</h1>

              <p>
                Magyne Carwash helps car wash businesses manage services,
                pricing, customers, sales, receipts and daily operations.
              </p>

              <button
                className="cta-btn"
                onClick={() => handleNavigate()}
              >
                Choose a Package
              </button>
            </div>
          </section>

          {/* Features */}

          <section className="carwash-features">
            <h2>Everything You Need To Run Your Carwash</h2>

            <div className="features-grid">
              <div className="feature-card">
                <h3>Customer & Vehicle Management</h3>

                <p className="details">
                  Register customers and vehicles, maintain complete service
                  history, and quickly retrieve previous visits.
                </p>

                <p className="benefits">
                  Benefits: Faster customer service, better retention, and complete
                  customer records.
                </p>
              </div>

              <div className="feature-card">
                <h3>Job Cards & POS</h3>

                <p className="details">
                  Create digital job cards, assign services, print invoices and
                  receipts, and process payments seamlessly.
                </p>

                <p className="benefits">
                  Benefits: Faster billing, reduced errors, and professional
                  receipts.
                </p>
              </div>

              <div className="feature-card">
                <h3>Employees & Shift Management</h3>

                <p className="details">
                  Manage staff, shifts, attendance, permissions, and performance
                  across multiple locations.
                </p>

                <p className="benefits">
                  Benefits: Improved accountability and efficient workforce
                  management.
                </p>
              </div>

              <div className="feature-card">
                <h3>Reports & Business Insights</h3>

                <p className="details">
                  Track daily sales, expenditures, customer trends, rewards,
                  services, and overall business performance.
                </p>

                <p className="benefits">
                  Benefits: Make informed business decisions with real-time
                  analytics.
                </p>
              </div>
            </div>
          </section>

          {/* CTA */}

          <section className="carwash-cta">
            <h2>Ready To Modernize Your Carwash?</h2>

            <p>
              Join businesses already simplifying their daily operations with
              Magyne Carwash. Spend less time on paperwork and more time growing
              your business.
            </p>

            <button
              className="cta-btn"
              onClick={() => handleNavigate()}
            >
              Choose a Package
            </button>
          </section>
            </>
          ) : !loading && !product && (
            <>
            <div className="login-card mt-lg-5 mb-lg-5">
              <div className="logo-container">
              <h3 className="page-title mb-2">Invalid product.</h3>
              <p>Unknown product name. please pick a valid industry in which you business belongs.</p>
                <p className="register-text">
                  We have our product here{" "}
                  <a href="/products">See products</a>
                </p>
            </div>
          </div>
          </>
          )
        }
      </div>
    </main>
    </>
  );
}